"use strict";
// COMMENTED OUT: Complex Winston-based logging system
// ================================================
//
// // Check if we're in Node.js environment
// const isNode =
//   typeof process !== "undefined" && process.versions && process.versions.node;
//
// // Logger interface for consistency
// interface Logger {
//   info(message: string, meta?: any): void;
//   warn(message: string, meta?: any): void;
//   error(message: string, meta?: any): void;
// }
//
// // Initialize logger synchronously based on environment
// let logger: Logger;
//
// if (!isNode) {
//   // Browser environment - no logging (no-op functions)
//   logger = {
//     info: () => {}, // no-op
//     warn: () => {}, // no-op
//     error: () => {}, // no-op
//   };
// } else {
//   // Node.js environment - use Winston with file logging
//   let winston: any, path: any, fs: any;
//
//   try {
//     // Dynamic loading - webpack ignores eval("require") calls
//     winston = eval('require("winston")');
//     path = eval('require("path")');
//     fs = eval('require("fs")');
//
//     // Safe to use process since we're in Node.js
//     const logDirectory = process.env.LOG_DIRECTORY || "./logs";
//     if (!fs.existsSync(logDirectory)) {
//       fs.mkdirSync(logDirectory, { recursive: true });
//     }
//
//     logger = winston.createLogger({
//       level: "info",
//       format: winston.format.combine(
//         winston.format.timestamp(),
//         winston.format.errors({ stack: true }),
//       ),
//       transports: [
//         // All logs (errors, warnings, info) to single file with readable format
//         new winston.transports.File({
//           filename: path.join(logDirectory, process.env.LOG_FILE || "logs.log"),
//           format: winston.format.combine(
//             winston.format.timestamp(),
//             winston.format.printf(
//               ({
//                 timestamp,
//                 level,
//                 message,
//                 component,
//                 operation,
//                 context,
//                 stack,
//               }: {
//                 timestamp: string;
//                 level: string;
//                 message: string;
//                 component?: string;
//                 operation?: string;
//                 context?: Record<string, any>;
//                 stack?: string;
//               }) => {
//                 const prefix =
//                   component && operation
//                     ? `${component}:${operation}`
//                     : "UNKNOWN:UNKNOWN";
//                 let logLine = `[${timestamp}] [${level.toUpperCase()}] ${prefix} ${message}`;
//
//                 // Add context if present
//                 if (context && Object.keys(context).length > 0) {
//                   logLine += `\n  Context: ${JSON.stringify(context, null, 2)}`;
//                 }
//
//                 // Add stack trace if present
//                 if (stack && typeof stack === "string") {
//                   logLine += `\n  Stack Trace:\n${stack
//                     .split("\n")
//                     .map((line) => `    ${line}`)
//                     .join("\n")}`;
//                 }
//
//                 return logLine + "\n"; // Add extra newline for separation
//               },
//             ),
//           ),
//         }),
//         // Console output
//         new winston.transports.Console({
//           format: winston.format.combine(
//             winston.format.colorize(),
//             winston.format.timestamp(),
//             winston.format.printf(
//               ({
//                 timestamp,
//                 level,
//                 message,
//                 component,
//                 operation,
//               }: {
//                 timestamp: string;
//                 level: string;
//                 message: string;
//                 component?: string;
//                 operation?: string;
//               }) => {
//                 const prefix =
//                   component && operation
//                     ? `${component}:${operation}`
//                     : "UNKNOWN:UNKNOWN";
//                 return `[${timestamp}] [${level}] ${prefix} ${message}`;
//               },
//             ),
//           ),
//         }),
//       ],
//     });
//   } catch (error) {
//     // Fallback to no-op if winston loading fails (shouldn't happen in Node.js)
//     logger = {
//       info: () => {}, // no-op
//       warn: () => {}, // no-op
//       error: () => {}, // no-op
//     };
//   }
// }
Object.defineProperty(exports, "__esModule", { value: true });
exports.logInfo = exports.logWarning = exports.logError = void 0;
// Helper function to serialize objects with BigInt values
const serializeForLogging = (obj) => {
    return JSON.stringify(obj, (key, value) => (typeof value === "bigint" ? value.toString() : value), 2);
};
// Simple console-based logging functions
const logError = (message, options = {}) => {
    const prefix = options.component && options.operation
        ? `${options.component}:${options.operation}`
        : "UNKNOWN:UNKNOWN";
    let errorMessage = `[ERROR] ${prefix} ${message}`;
    if (options.context && Object.keys(options.context).length > 0) {
        errorMessage += `\nContext: ${serializeForLogging(options.context)}`;
    }
    if (options.error?.stack) {
        errorMessage += `\nStack: ${options.error.stack}`;
    }
    console.error(errorMessage);
};
exports.logError = logError;
const logWarning = (message, options = {}) => {
    const prefix = options.component && options.operation
        ? `${options.component}:${options.operation}`
        : "UNKNOWN:UNKNOWN";
    let warningMessage = `[WARNING] ${prefix} ${message}`;
    if (options.context && Object.keys(options.context).length > 0) {
        warningMessage += `\nContext: ${serializeForLogging(options.context)}`;
    }
    console.warn(warningMessage);
};
exports.logWarning = logWarning;
const logInfo = (message, options = {}) => {
    const prefix = options.component && options.operation
        ? `${options.component}:${options.operation}`
        : "UNKNOWN:UNKNOWN";
    let infoMessage = `[INFO] ${prefix} ${message}`;
    if (options.context && Object.keys(options.context).length > 0) {
        infoMessage += `\nContext: ${serializeForLogging(options.context)}`;
    }
    console.log(infoMessage);
};
exports.logInfo = logInfo;
// COMMENTED OUT: logException function (not needed)
// export const logException = (
//   error: Error,
//   options: {
//     component?: string;
//     operation?: string;
//     context?: Record<string, any>;
//   } = {},
// ): void => {
//   logError(error.message, {
//     ...options,
//     error,
//   });
// };
// COMMENTED OUT: createScopedLogger function (references removed logException)
// export const createScopedLogger = (component: string, operation?: string) => {
//   return {
//     logError: (
//       message: string,
//       context?: Record<string, any>,
//       error?: Error,
//     ) => {
//       logError(message, { component, operation, context, error });
//     },
//
//     logWarning: (message: string, context?: Record<string, any>) => {
//       logWarning(message, { component, operation, context });
//     },
//
//     logInfo: (message: string, context?: Record<string, any>) => {
//       logInfo(message, { component, operation, context });
//     },
//
//     logException: (error: Error, context?: Record<string, any>) => {
//       logException(error, { component, operation, context });
//     },
//   };
// };
// COMMENTED OUT: Winston logger export
// export { logger };
//# sourceMappingURL=logger.js.map